// SpeakerManagement.js: Admin page for managing event speakers
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import ReactCountryFlag from 'react-country-flag';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Typography, Paper, Button, Grid, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import DeleteIcon from '@mui/icons-material/Delete';
import SuperAdminLayout from '../../layouts/SuperAdminLayout';
import api from '../../services/api';
import SpeakerBadgeCard from '../../components/SpeakerBadgeCard';

function SpeakerManagement() {
        async function handleVerifySpeaker(speaker) {
          try {
            await api.post(`/api/bookings/${speaker._id}/approve`);
            setSpeakers(prev => prev.map(s => s._id === speaker._id ? { ...s, status: 'approved' } : s));
            setDetailSpeaker(s => s ? { ...s, status: 'approved' } : s);
            setSnackbar({ open: true, message: 'Speaker verified and ready for ticket processing.', severity: 'success' });
          } catch (err) {
            setSnackbar({ open: true, message: err.response?.data?.error || 'Failed to verify speaker.', severity: 'error' });
          }
        }
      // Helper to get ISO country code from country name
      function getCountryCode(countryName) {
        if (!countryName) return '';
        const countries = {
          'Tanzania': 'TZ', 'Kenya': 'KE', 'Uganda': 'UG', 'Nigeria': 'NG', 'South Africa': 'ZA', 'United States': 'US', 'United Kingdom': 'GB', 'Japan': 'JP', 'India': 'IN', 'China': 'CN', 'Germany': 'DE', 'France': 'FR', 'Canada': 'CA', 'Australia': 'AU', 'Italy': 'IT', 'Spain': 'ES', 'Netherlands': 'NL', 'Sweden': 'SE', 'Norway': 'NO', 'Finland': 'FI', 'Ghana': 'GH', 'Egypt': 'EG', 'Morocco': 'MA', 'Ethiopia': 'ET', 'Rwanda': 'RW', 'Burundi': 'BI', 'Zambia': 'ZM', 'Zimbabwe': 'ZW', 'Botswana': 'BW', 'Malawi': 'MW', 'Mozambique': 'MZ', 'DR Congo': 'CD', 'South Sudan': 'SS', 'Somalia': 'SO', 'Sudan': 'SD', 'Senegal': 'SN', 'Ivory Coast': 'CI', 'Cameroon': 'CM', 'Angola': 'AO', 'Gabon': 'GA', 'Congo': 'CG', 'Benin': 'BJ', 'Togo': 'TG', 'Mali': 'ML', 'Burkina Faso': 'BF', 'Niger': 'NE', 'Libya': 'LY', 'Tunisia': 'TN', 'Algeria': 'DZ', 'Sierra Leone': 'SL', 'Liberia': 'LR', 'Guinea': 'GN', 'Guinea-Bissau': 'GW', 'Gambia': 'GM', 'Chad': 'TD', 'Central African Republic': 'CF', 'Mauritania': 'MR', 'Namibia': 'NA', 'Lesotho': 'LS', 'Swaziland': 'SZ', 'Madagascar': 'MG', 'Comoros': 'KM', 'Seychelles': 'SC', 'Mauritius': 'MU', 'Cape Verde': 'CV', 'Sao Tome and Principe': 'ST', 'Djibouti': 'DJ', 'Eritrea': 'ER', 'South Korea': 'KR', 'North Korea': 'KP', 'Russia': 'RU', 'Brazil': 'BR', 'Mexico': 'MX', 'Argentina': 'AR', 'Chile': 'CL', 'Colombia': 'CO', 'Peru': 'PE', 'Venezuela': 'VE', 'Ecuador': 'EC', 'Bolivia': 'BO', 'Paraguay': 'PY', 'Uruguay': 'UY', 'Panama': 'PA', 'Costa Rica': 'CR', 'Guatemala': 'GT', 'Honduras': 'HN', 'El Salvador': 'SV', 'Nicaragua': 'NI', 'Cuba': 'CU', 'Dominican Republic': 'DO', 'Haiti': 'HT', 'Jamaica': 'JM', 'Trinidad and Tobago': 'TT', 'Bahamas': 'BS', 'Barbados': 'BB', 'Saint Lucia': 'LC', 'Saint Vincent and the Grenadines': 'VC', 'Grenada': 'GD', 'Antigua and Barbuda': 'AG', 'Dominica': 'DM', 'Saint Kitts and Nevis': 'KN', 'Belize': 'BZ', 'Guyana': 'GY', 'Suriname': 'SR', 'Vatican City': 'VA', 'Monaco': 'MC', 'San Marino': 'SM', 'Andorra': 'AD', 'Liechtenstein': 'LI', 'Luxembourg': 'LU', 'Switzerland': 'CH', 'Austria': 'AT', 'Belgium': 'BE', 'Ireland': 'IE', 'Portugal': 'PT', 'Greece': 'GR', 'Turkey': 'TR', 'Israel': 'IL', 'Saudi Arabia': 'SA', 'United Arab Emirates': 'AE', 'Qatar': 'QA', 'Kuwait': 'KW', 'Bahrain': 'BH', 'Oman': 'OM', 'Yemen': 'YE', 'Jordan': 'JO', 'Lebanon': 'LB', 'Syria': 'SY', 'Iraq': 'IQ', 'Iran': 'IR', 'Pakistan': 'PK', 'Afghanistan': 'AF', 'Bangladesh': 'BD', 'Nepal': 'NP', 'Bhutan': 'BT', 'Sri Lanka': 'LK', 'Maldives': 'MV', 'Thailand': 'TH', 'Vietnam': 'VN', 'Malaysia': 'MY', 'Singapore': 'SG', 'Indonesia': 'ID', 'Philippines': 'PH', 'Myanmar': 'MM', 'Cambodia': 'KH', 'Laos': 'LA', 'Mongolia': 'MN', 'Kazakhstan': 'KZ', 'Uzbekistan': 'UZ', 'Turkmenistan': 'TM', 'Kyrgyzstan': 'KG', 'Tajikistan': 'TJ', 'Georgia': 'GE', 'Armenia': 'AM', 'Azerbaijan': 'AZ', 'Ukraine': 'UA', 'Belarus': 'BY', 'Poland': 'PL', 'Czech Republic': 'CZ', 'Slovakia': 'SK', 'Hungary': 'HU', 'Romania': 'RO', 'Bulgaria': 'BG', 'Serbia': 'RS', 'Croatia': 'HR', 'Bosnia and Herzegovina': 'BA', 'Montenegro': 'ME', 'Albania': 'AL', 'North Macedonia': 'MK', 'Slovenia': 'SI', 'Estonia': 'EE', 'Latvia': 'LV', 'Lithuania': 'LT', 'Moldova': 'MD', 'Iceland': 'IS', 'Greenland': 'GL', 'Fiji': 'FJ', 'Papua New Guinea': 'PG', 'Solomon Islands': 'SB', 'Vanuatu': 'VU', 'Samoa': 'WS', 'Tonga': 'TO', 'Kiribati': 'KI', 'Tuvalu': 'TV', 'Palau': 'PW', 'Micronesia': 'FM', 'Marshall Islands': 'MH', 'Nauru': 'NR', 'East Timor': 'TL'
        };
        if (countries[countryName]) return countries[countryName];
        const normalized = countryName.trim().toLowerCase();
        for (const key in countries) {
          if (key.trim().toLowerCase() === normalized) return countries[key];
        }
        return '';
      }
    // Assume currentUser is available from context or props
    const currentUser = { role: 'superadmin' }; // Replace with actual user context
    const [detailOpen, setDetailOpen] = useState(false);
    const [detailSpeaker, setDetailSpeaker] = useState(null);
    const [deleteError, setDeleteError] = useState('');
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  // Fetch speakers from selected source
  useEffect(() => {
    setLoading(true);
    setError('');
    api.get('/api/bookings/approved-speakers')
      .then(res => {
        const all = Array.isArray(res.data) ? res.data : [];
        setSpeakers(all);
      })
      .catch(err => setError(err.response?.data?.error || 'Failed to fetch speakers'))
      .finally(() => setLoading(false));
  }, []);


  // Speaker add/delete logic can be re-implemented if needed for admin

  return (
    <SuperAdminLayout>
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h4" fontWeight="bold" mb={2} color="primary">Speaker Management</Typography>
        <Paper sx={{ p: 3, borderRadius: 3, mb: 3 }}>
          {error && <Typography color="error" mb={2}>{error}</Typography>}
          {loading ? (
            <Typography>Loading...</Typography>
          ) : (
            <Grid container spacing={3}>
              {speakers.length === 0 ? (
                <Grid item xs={12}><Typography>No speakers found.</Typography></Grid>
              ) : speakers.map((speaker) => (
                <Grid item xs={12} sm={6} md={4} key={speaker._id}>
                  <Paper sx={{
                    p: 2,
                    borderRadius: 2,
                    boxShadow: 2,
                    mb: 2,
                    background: theme => theme.palette.mode === 'dark' ? '#23232b' : '#f9f9fb',
                    color: theme => theme.palette.mode === 'dark' ? '#fff' : '#222',
                    transition: 'background 0.2s',
                  }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="h6" fontWeight={700} color="primary.main" noWrap sx={{ fontSize: 17 }}>
                          {speaker.bookingDetails?.bookerName || speaker.bookingDetails?.companyDetails?.name || speaker.name}
                        </Typography>
                        {speaker.bookingDetails?.country && (
                          <span title={speaker.bookingDetails.country} style={{ fontSize: 18 }}>
                            <ReactCountryFlag countryCode={speaker.bookingDetails.country.length === 2 ? speaker.bookingDetails.country : (speaker.bookingDetails.country ? speaker.bookingDetails.country.slice(0,2).toUpperCase() : '')} svg style={{ width: '1.5em', height: '1.5em', borderRadius: '3px', boxShadow: '0 0 2px #aaa' }} />
                          </span>
                        )}
                        <IconButton size="small" color="info" onClick={() => { setDetailSpeaker(speaker); setDetailOpen(true); }}>
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                        {speaker.status === 'approved' && (
                          <Tooltip title="Verified">
                            <CheckCircleIcon color="success" fontSize="small" sx={{ ml: 1 }} />
                          </Tooltip>
                        )}
                        {speaker.paymentStatus === 'paid' && (
                          <Tooltip title="Paid">
                            <span style={{ color: '#388e3c', fontSize: 18, marginLeft: 2 }}>$</span>
                          </Tooltip>
                        )}
                        {currentUser.role === 'superadmin' && (
                          <Tooltip title="Delete Speaker">
                            <IconButton size="small" color="error" onClick={async () => {
                              setDeleteError('');
                              try {
                                await api.delete(`/api/bookings/${speaker._id}`);
                                setSpeakers(prev => prev.filter(s => s._id !== speaker._id));
                              } catch (err) {
                                setDeleteError(err.response?.data?.error || 'Failed to delete speaker');
                              }
                            }}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {currentUser.role === 'staff' && (
                          <Tooltip title="No Permission">
                            <IconButton size="small" color="error" onClick={() => setDeleteError('No Permission!')}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                      <Typography variant="body2" color="text.secondary" noWrap sx={{ fontSize: 14 }}>
                        <b>Email:</b> {speaker.userId?.email || speaker.bookingDetails?.email || speaker.email || 'N/A'}
                      </Typography>
                      <Typography variant="body2" noWrap sx={{ fontSize: 14 }}>
                        <b>Contact:</b> {speaker.bookingDetails?.mobile || speaker.mobile || 'N/A'}
                      </Typography>
                      <Typography variant="body2" noWrap sx={{ fontSize: 14 }}>
                        <b>Package:</b> {speaker.packageId?.name || '-'} | <b>Category:</b> {speaker.packageId?.category || '-'}
                      </Typography>
                      <Typography variant="body2" noWrap sx={{ fontSize: 14 }}>
                        <b>Status:</b> {speaker.status || '-'} | <b>Payment:</b> {speaker.paymentStatus || '-'}
                      </Typography>
                      <Typography variant="body2" noWrap sx={{ fontSize: 14 }}>
                        <b>Topic:</b> {speaker.bookingDetails?.topic || speaker.topic || '-'}
                      </Typography>
                    </Box>
                    {deleteError && <Typography color="error" sx={{ mt: 1 }}>{deleteError}</Typography>}
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
          {/* Speaker Detail Popup */}
          <Dialog open={detailOpen} onClose={() => setDetailOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Speaker Details</DialogTitle>
            <DialogContent>
              {detailSpeaker && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                  <Typography variant="h6" fontWeight={700} color="primary.main">{detailSpeaker.bookingDetails?.bookerName || detailSpeaker.bookingDetails?.companyDetails?.name || detailSpeaker.name}</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {detailSpeaker.packageId?.price && (
                      <Typography variant="body2" sx={{ color: '#007bff', fontWeight: 700, fontSize: 15 }}>
                        <span style={{ fontSize: 15, marginRight: 4 }}>💵</span> ${detailSpeaker.packageId.price}
                      </Typography>
                    )}
                    {detailSpeaker.bookingDetails?.country && (
                      <span title={detailSpeaker.bookingDetails.country} style={{ fontSize: 18 }}>
                        <ReactCountryFlag countryCode={getCountryCode(detailSpeaker.bookingDetails.country)} svg style={{ width: '1.5em', height: '1.5em', borderRadius: '3px', boxShadow: '0 0 2px #aaa' }} />
                      </span>
                    )}
                  </Box>
                  <Typography variant="body2"><b>Name:</b> {detailSpeaker.bookingDetails?.bookerName || detailSpeaker.bookingDetails?.companyDetails?.name || detailSpeaker.name}</Typography>
                  <Typography variant="body2"><b>Email:</b> {detailSpeaker.userId?.email || detailSpeaker.bookingDetails?.email || detailSpeaker.email || 'N/A'}</Typography>
                  <Typography variant="body2"><b>Mobile:</b> {detailSpeaker.bookingDetails?.mobile || detailSpeaker.mobile || 'N/A'}</Typography>
                  <Typography variant="body2"><b>Country:</b> {detailSpeaker.bookingDetails?.country || '-'}</Typography>
                  <Typography variant="body2"><b>City:</b> {detailSpeaker.bookingDetails?.city || '-'}</Typography>
                  <Typography variant="body2"><b>Address:</b> {detailSpeaker.bookingDetails?.address || '-'}</Typography>
                  <Typography variant="body2"><b>Company:</b> {detailSpeaker.bookingDetails?.companyName || detailSpeaker.bookingDetails?.companyDetails?.name || '-'}</Typography>
                  <Typography variant="body2"><b>Status:</b> {detailSpeaker.status || '-'} | <b>Payment:</b> {detailSpeaker.paymentStatus || '-'}</Typography>
                  <Typography variant="body2"><b>Topic:</b> {detailSpeaker.bookingDetails?.topic || detailSpeaker.topic || '-'}</Typography>
                  <Typography variant="body2"><b>Category:</b> {detailSpeaker.packageId?.category || detailSpeaker.bookingDetails?.category || '-'}</Typography>
                   {(currentUser.role === 'superadmin' || currentUser.role === 'admin') && detailSpeaker.status !== 'approved' && (
                     <Button variant="contained" color="success" sx={{ mt: 2 }} onClick={() => handleVerifySpeaker(detailSpeaker)}>
                       Verify Speaker
                     </Button>
                   )}
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDetailOpen(false)}>Close</Button>
            </DialogActions>
          </Dialog>
        </Paper>
      </Box>
    </SuperAdminLayout>
  );
}

export default SpeakerManagement;
